import { render, staticRenderFns } from "./editClassBj.vue?vue&type=template&id=5e322866&scoped=true"
import script from "./editClassBj.vue?vue&type=script&lang=js"
export * from "./editClassBj.vue?vue&type=script&lang=js"
import style0 from "./editClassBj.vue?vue&type=style&index=0&id=5e322866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e322866",
  null
  
)

export default component.exports